import React from 'react';
import HorizonTimeline from './HorizonTimeline';
import { buildRows } from './horizonPlan';
import { formatAnchor } from './horizonTime';
import './HorizonPrint.css';

/** Fit the complete Month grid inside the selected landscape sheet. */
export function printScale(horizon, paper) {
  const width = 600 + horizon.weeks * 10;
  const height = buildRows(horizon, new Set()).reduce(
    (sum, row) => sum + (row.kind === 'section' ? 34 : 36), 106,
  );
  const bounds = paper === 'A4' ? { width: 1040, height: 620 } : { width: 1510, height: 960 };
  return Math.min(1, bounds.width / width, bounds.height / height);
}

export default function HorizonPrint({ horizon, project, paper, now, showLinks }) {
  return (
    <div className="hzpage-print" data-theme="light">
      <style media="print">{`@page { size: ${paper === 'A4' ? 'A4' : 'A3'} landscape; margin: 10mm; }`}</style>
      <h1>{project.name} · {horizon.name}</h1>
      <p>{formatAnchor(horizon.anchorDate, horizon.weeks)}</p>
      <div className="hzpage-print-plan" style={{ '--hz-print-scale': printScale(horizon, paper) }}>
        <HorizonTimeline horizon={horizon} zoom="month" now={now} showLinks={showLinks}
          selectedId={null} onRowClick={() => {}} onReorder={() => {}} />
      </div>
    </div>
  );
}
